module.exports = __webpack_public_path__ + "assets/stories-bg-0.5x.09bab501.webp";